import { mapState } from 'pinia'
import { formatMoneyWithCurrency } from '@/plugins/numformat'
import { useRootStore } from '@/store/root'
import { bgnToEur, CurrencyCode } from '@/plugins/currencyFormatters'

export default {
  computed: {
    ...mapState(useRootStore, ['locale', 'isBgMultiCurrencyActive'])
  },
  methods: {
    formatBGNToEuro (amount, currency) {
      if (currency === CurrencyCode.BGN && this.isBgMultiCurrencyActive) {
        return formatMoneyWithCurrency(bgnToEur(amount), CurrencyCode.EUR, this.locale)
      }
      return null
    }
  }
}
